import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  padding-top: 180px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pageBackground};

  ${mediaMaxWidth.phone} {
    padding-top: 150px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
  min-height: 600px;
  margin-bottom: 100px;
  align-items: center;
  position: relative;
  padding: 0 1rem;

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
  }
`;

export const Page = styled.div`
  h1 {
    margin: 0;
  }

  #action-bar {
    top: 90px;
  }

  ${mediaMaxWidth.tablet} {
    #action-bar {
      top: 70px;
      transition: 0s;
    }
  }
`;
